/*
 * Sedelle Hair contact form (snippets/sedelle-concierge-form.liquid) and the salon-finding dialog
 * (sections/sedelle-salon-service.liquid):
 * - shows the "Tu zona" part only for the topics that need it, and words the submit button after
 *   the topic ("Solicitar mi peluquería", "Consultar mi pedido"...);
 * - opens the dialog from [data-open-dialog] links (they fall back to the contact page without JS),
 *   closes it with its button, Escape or a click on the backdrop;
 * - reopens the dialog after the form is sent, so the thank-you or error message is seen.
 */
(() => {
  if (window.sedelleConcierge) return;
  window.sedelleConcierge = true;

  const syncZone = (select) => {
    const form = select.closest('form');
    const zone = form && form.querySelector('[data-concierge-zone]');
    if (zone) {
      const topics = (select.dataset.zoneTopics || '').split('|');
      zone.toggleAttribute('data-zone-hidden', !topics.includes(select.value));
    }
    const submit = form && form.querySelector('[data-concierge-submit]');
    const label = select.selectedOptions[0] && select.selectedOptions[0].dataset.submitLabel;
    if (submit && label) submit.textContent = label;
  };

  const openDialog = (dialog) => {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.documentElement.classList.add('sedelle-dialog-open');
  };

  const init = () => {
    document.querySelectorAll('[data-concierge-topic]').forEach((select) => {
      select.addEventListener('change', () => syncZone(select));
    });

    document.querySelectorAll('[data-open-dialog]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const dialog = document.getElementById(link.dataset.openDialog);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        openDialog(dialog);
        const first = dialog.querySelector('input:not([type="hidden"]), select, textarea');
        if (first) first.focus();
      });
    });

    document.querySelectorAll('dialog[data-concierge-dialog]').forEach((dialog) => {
      dialog.addEventListener('close', () => document.documentElement.classList.remove('sedelle-dialog-open'));
      dialog.querySelectorAll('[data-close-dialog]').forEach((button) => button.addEventListener('click', () => dialog.close()));
      // A click on the backdrop (outside the panel) closes it.
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      if (dialog.querySelector('[data-form-status]')) openDialog(dialog);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
